import { FC } from "react";
import BlogPost from "../models/blogPost";
import { Card, CardActionArea, CardContent, CardMedia, Link, Stack, Typography, useTheme } from "@mui/material";
import { getPublicBlogPostHeroImageUrl } from "../utils/fileUtils";
import { formatDate } from "../utils/formatUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
	blogPost: BlogPost;
};

const BlogPostCard: FC<Props> = ({ blogPost }) => {
	const theme = useTheme();

	return (
		<Card sx={{ display: 'flex', flexDirection: 'column', width: 360 }}>
			<CardActionArea sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
				<CardMedia
					image={getPublicBlogPostHeroImageUrl(blogPost)}
					title={blogPost.title}
					sx={{ width: '100%', height: 180 }}
				/>
				<CardContent
					component="a"
					href={`blog/${blogPost.slug}`}
					sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
				>
					<Stack spacing={2} flex={1} justifyContent="space-between" px={1} pb={1}>
						<Stack spacing={2}>
							<Stack>
								<Stack direction="row" spacing={1} alignItems="center">
									<Typography variant="caption" color="textSecondary">
										{formatDate(blogPost.publishDate, 'MMMM D, YYYY')}
									</Typography>
									<FontAwesomeIcon icon="circle" style={{ color: theme.palette.text.secondary, fontSize: '0.3rem' }} />
									<Typography variant="caption" color="textSecondary">Tim Kulig</Typography>
								</Stack>
								<Typography variant="h6" color="textPrimary">
									{blogPost.title}
								</Typography>
							</Stack>
							<Typography variant="body2" color="textSecondary">
								{blogPost.abstract}
							</Typography>
						</Stack>
						<Link sx={{ textTransform: 'uppercase' }} href={`blog/${blogPost.slug}`}>Read more...</Link>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default BlogPostCard;
